import { SET_IS_EDITOR_OPEN, SET_SHORTCUT_DISABLE_STATUS, SET_SHORTCUT_MODAL_OPEN_STATUS } from './shortcutsTypes';

export const setShortcutsDisableStatus = (status) => {
  return {
    type: SET_SHORTCUT_DISABLE_STATUS,
    payload: status,
  };
};

export const setEditorOpenStatus = (status) => {
  return {
    type: SET_IS_EDITOR_OPEN,
    payload: status,
  };
};

export const setShortcutModalOpenStatus = (status) => {
  return {
    type: SET_SHORTCUT_MODAL_OPEN_STATUS,
    payload: status,
  };
};
